import * as React from 'react';
import type { SVGProps } from 'react';

const SvgAiSparkle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 10 10"
    {...props}
  >
    <defs>
      <linearGradient id="animatedGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3752b3">
          <animate
            attributeName="stop-color"
            values="#3752b3; #de5930; #3752b3"
            dur="3s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="100%" stopColor="#de5930">
          <animate
            attributeName="stop-color"
            values="#de5930; #3752b3; #de5930"
            dur="3s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
    <path
      fill="url(#animatedGradient)"
      d="M4.227.58c.226-.773 1.32-.773 1.546 0l.33 1.128a3.22 3.22 0 0 0 2.189 2.189l1.128.33c.773.226.773 1.32 0 1.546l-1.128.33a3.22 3.22 0 0 0-2.189 2.189l-.33 1.128c-.226.773-1.32.773-1.546 0l-.33-1.128a3.22 3.22 0 0 0-2.189-2.189L.58 5.773c-.773-.226-.773-1.32 0-1.546l1.128-.33a3.22 3.22 0 0 0 2.189-2.189z"
    />
  </svg>
);
export default SvgAiSparkle;
